import { render, staticRenderFns } from "./ItemRegisterComponent.vue?vue&type=template&id=c67d68ba&scoped=true"
import script from "./ItemRegisterComponent.vue?vue&type=script&lang=js"
export * from "./ItemRegisterComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c67d68ba",
  null
  
)

export default component.exports